import React, { useEffect, useState } from 'react';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  RetentionLifetimeMetricColumn,
  retentionLifetimeOptions,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import { Table } from 'tea-component';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { useIntl } from 'umi';

const { pageable } = Table.addons;

const TrendsCard = (props: any) => {
  const { tableData = [], entityType } = props;

  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'date',
    currentRatioType: 0,
  });
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData: tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    setSortTableData(sortTable);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    //DAU Revenue Download 每个数据源赋值一遍
    retentionLifetimeOptions?.forEach((t) => {
      metricCloums.push(
        RetentionLifetimeMetricColumn({
          dataSource: 'sensortower',
          title: t.title,
          svgIcon: SensorTowerIcon,
          textContent: t?.textContent,
          key: `${t.key}`,
          metricKey: t?.metricKey || t?.key,
          sortMetric: t.key,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          isNoDropdown: true,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'app_id',
            header: 'Countries',
            width: 200,
            align: 'left',
            render: (cvm: any) => (
              <div className="table-countries">
                <img src={getCountryFlag('global')} className="countries-img" />
                <span className="countries-text">Global</span>
              </div>
            ),
          },
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            pageSizeOptions: [5, 10, 15],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
